import { useParams } from "react-router";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "@refinedev/react-hook-form";

import { PartnerFormValues, partnerSchema } from "@modules/partners/validations";
import { useEditPartnerMutation } from "@modules/partners/services/mutations";

export function usePartnerEditForm() {
  const { id } = useParams();
  const { mutateAsync, isPending } = useEditPartnerMutation(id as string);

  const methods = useForm<PartnerFormValues>({
    resolver: zodResolver(partnerSchema()),
    defaultValues: {
      active: true,
    },
    mode: "onBlur",
  });

  const {
    handleSubmit,
    refineCore: { formLoading },
  } = methods;

  return {
    methods,
    handleSubmit,
    mutateAsync,
    isPending,
    formLoading,
    id,
  };
}
